import PromotionListingPage from './promotion-list';

interface IBundleDiscountPromo {}

const BundleDiscountPromo: React.FunctionComponent<IBundleDiscountPromo> = props => {
  return <PromotionListingPage promo={'BUNDLE_DISC'} promoName="Bundle Discount" />;
};

export default BundleDiscountPromo;
